import React, { Component } from 'react'
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Form,
  FormGroup,
  FormText,
  Label,
  Input, 
  InputGroup,
  InputGroupAddon,
  Badge,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap"
import classnames from 'classnames'
import AddMemberBadge from './AddMemberBadge'
import AddManagerBadge from './AddManagerBadge'

const has = require('mout/object/has')

class ManageGroups extends Component {
  constructor (props) {
    super(props)

    this.state = {
      activeTab: 'Members'
    }

    this.toggle = this.toggle.bind(this)  

  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  render () {
    let groupsToArray = []
    for (var prop in this.props.groupsList) {
      if (this.props.groupsList.hasOwnProperty(prop)) {
        groupsToArray.push(this.props.groupsList[prop])
      }
    }
    groupsToArray.sort((a,b) => b.createdDate - a.createdDate)
    const groupsToRows = groupsToArray.map( (group) => {
      return <tr key={group.groupId}>
        <td>{group.groupName}</td>
        <td>{group.groupType}</td>
      </tr>
    }) 

    let membershipGroupsRows
    this.props.groupsList
    ? membershipGroupsRows = this.props.groupsList.map((group, n) => {
        let rowColor = ''
        if (this.props.activeGroup) {
          group.groupId === this.props.activeGroup.groupId
          ? rowColor = 'bg-info'
          : null
        }

        return ( 
          <tr 
            key={'membershipGroupsRow' + n}
            onClick={() => this.props.setActiveGroup(group)}
            className={rowColor}
          >
            <td>{group.groupName}</td>
            <td>{group.groupType}</td>
          </tr>
        )
      })
    : membershipGroupsRows = <tr></tr>

    const membershipTable = <Table>
        <thead>
          <tr>
            <th>Group Name</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          {membershipGroupsRows}
        </tbody>
      </Table>

    let usersRows
    this.props.users
    ? usersRows = this.props.users.map((user, n) => {
        let rowColor = ''
        if (has(this.props, 'activeGroup.members.' + user.uid)) {
          if (this.props.activeGroup.members[user.uid]) {
            rowColor = 'bg-info'
          }
        }

        if (has(this.props, 'activeGroup.managers.' + user.uid)) {
          if (this.props.activeGroup.managers[user.uid]) {
            rowColor === 'bg-info'
            ? rowColor = 'bg-secondary'
            : rowColor = 'bg-warning'
          }
        }

/*        if (this.props.activeGroup) {
          if (this.props.activeGroup.members) {
            if (this.props.activeGroup.members[user.uid]) {
              rowColor = 'bg-info'
            }
          }
        }   */



        let gid = ''
        if (this.props.activeGroup) {
          gid = this.props.activeGroup.groupId
        }
        return (
          <tr 
            key={'usersRows' + n}
            className={rowColor}
          >
            <td>{user.displayName}</td>
            <td>{user.email}</td>
            <td>
              <AddMemberBadge
                  uid={user.uid}
                  groupId={gid}
                  addMember={this.props.addMember}
                  removeMember={this.props.removeMember}
                  add={rowColor === '' || rowColor === 'bg-warning'}
              />  
            </td>
            <td>
              <AddManagerBadge
                uid={user.uid}
                groupId={gid}
                addManager={this.props.addManager}
                removeManager={this.props.removeManager}
                add={rowColor === '' || rowColor === 'bg-info'}
              />
            </td>
          </tr>
        )
      })
    : usersRows = <tr></tr>

    const usersTable = (
      <Table>
        <thead>
          <tr>
            <th>User Name</th>
            <th>Email</th>
            <th>Add</th>
            <th>Lead</th>
          </tr>
        </thead>
        <tbody>
          {usersRows}
        </tbody>
      </Table>
    )

    return (
      <div className='animated fadeIn'>
        <Row>
          <Col xs='12' md ='12' className='mb-4'>
            <Nav tabs>
              <NavItem>
                  <NavLink
                    className={classnames({ active: this.state.activeTab === 'Edit'})}
                    onClick={() => {this.toggle('Edit')}}
                  >
                    Edit Groups
                  </NavLink>
              </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: this.state.activeTab === 'Create'})}
                    onClick={() => {this.toggle('Create')}}
                  >
                    Create New Groups
                  </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === 'Members'})}
                  onClick={() => {this.toggle('Members')}}
                >
                  Members
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId='Edit'>
                <Table responsive size="sm">
                  <thead>
                  <tr>
                    <th>Username</th>
                    <th>Date registered</th>
                    <th>Role</th>
                    <th>Status</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Carwyn Fachtna</td>
                    <td>2012/01/01</td>
                    <td>Member</td>
                    <td>
                      <Badge color="success">Active</Badge>
                    </td>
                  </tr>
                  <tr>
                    <td>Nehemiah Tatius</td>
                    <td>2012/02/01</td>
                    <td>Staff</td>
                    <td>
                      <Badge color="danger">Banned</Badge>
                    </td>
                  </tr>
                  <tr>
                    <td>Ebbe Gemariah</td>
                    <td>2012/02/01</td>
                    <td>Admin</td>
                    <td>
                      <Badge color="secondary">Inactive</Badge>
                    </td>
                  </tr>
                  <tr>
                    <td>Eustorgios Amulius</td>
                    <td>2012/03/01</td>
                    <td>Member</td>
                    <td>
                      <Badge color="warning">Pending</Badge>
                    </td>
                  </tr>
                  <tr>
                    <td>Leopold Gáspár</td>
                    <td>2012/01/21</td>
                    <td>Staff</td>
                    <td>
                      <Badge color="success">Active</Badge>
                    </td>
                  </tr>
                  </tbody>
                </Table>
                <Pagination>
                  <PaginationItem><PaginationLink previous href="#">Prev</PaginationLink></PaginationItem>
                  <PaginationItem active>
                    <PaginationLink href="#">1</PaginationLink>
                  </PaginationItem>
                  <PaginationItem><PaginationLink href="#">2</PaginationLink></PaginationItem>
                  <PaginationItem><PaginationLink href="#">3</PaginationLink></PaginationItem>
                  <PaginationItem><PaginationLink href="#">4</PaginationLink></PaginationItem>
                  <PaginationItem><PaginationLink next href="#">Next</PaginationLink></PaginationItem>
                </Pagination>
              </TabPane>
              <TabPane tabId='Create'>
                <Row>
                  <Col xs='12' md ='6' className='mb-4'>
                    <Form className="form-horizontal" onSubmit={this.props.handleSubmit}>
                    <FormGroup>
                        <Label htmlFor='groupType'>Group Type</Label>
                        <InputGroup>
                          <Input type='select' name='groupType' onChange={this.props.handleChange}>
                            <option>District</option>
                            <option>School</option>
                            <option>Teacher</option>
                            <option>Class</option>
                            <option>Company</option>
                            <option>Other</option>
                          </Input>
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="appendedInputButton">Add Group</Label>
                        <div className="controls">
                          <InputGroup>
                            <Input 
                              id="appendedInputButton" 
                              name='groupName' 
                              size="16" 
                              type="text" 
                              onChange={this.props.handleChange}
                              value={this.props.groupName}  
                            />
                            <InputGroupAddon addonType='append'><Button color="secondary">Add</Button></InputGroupAddon>
                          </InputGroup>
                        </div>
                      </FormGroup>
                    </Form>
                  </Col>
                  <Col xs='12' md ='6' className='mb-4'>
                    <h3>Groups Recently Added</h3>
                    <Table responsive size="sm">
                      <thead>
                        <tr>
                          <th>Group</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {groupsToRows}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId='Members'>
                <Row>
                  <Col>
                    Select a Group
                    {membershipTable}
                  </Col>
                  <Col>
                    Add Members and Leaders
                    {usersTable}
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Col>
          
        </Row>
      </div>

    )
  }

}

export default ManageGroups


// WEBPACK FOOTER //
// ./src/components/Users/ManageGroups.js